const repairLog = {
  backbtn: "Atrás",
  title: "CREAR NUEVO REGISTRO DE REPARACION",
  tag: "TAG del Activo",
  createdby: "Creado por",
  log: "Registro",
  submitbtn: "ENVIAR"
};

export default repairLog;
